// Utilities
import { animateComponents } from '../util/animations'
import { TweenLite, Power0, Power3, TimelineLite, SteppedEase } from 'gsap'

// Components
import FullscreenSlideshow from '../components/FullscreenSlideshow'
import Slider from '../components/Slider'
import BannerMosaic from '../components/BannerMosaic'
import BulletNav from '../components/BulletNav'
import InstagramFeed from '../components/InstagramFeed'
import VLine from '../components/VLine'
import SidebarContent from '../components/SidebarContent'
import EntryCover from '../components/EntryCover'
import PressEntryListed from '../components/PressEntryListed'
import EntryListed from '../components/EntryListed'
import ProductRelatedListed from '../components/ProductRelatedListed'
import ProductCategoryMore from '../components/ProductCategoryMore'
import GalleryItem from '../components/GalleryItem'
import ProductEntryHero from '../components/ProductEntryHero'
import ArchiveHeader from '../components/ArchiveHeader'

// Dependencies
import TimelineMax from 'gsap/TimelineMax'

let masterTimeline

let firstRun = true

const startInit = () => {
  animateComponents()
  $('.v-line').each((i, el) => new VLine($(el)))
  $('.instagram-feed').each((i, el) => new InstagramFeed($(el)))
  $('.bullet-nav').each((i, el) => new BulletNav($(el)))
  $('.banner-mosaic').each((i, el) => new BannerMosaic($(el)))
  $('.fullscreen-slideshow').each((i, el) => new FullscreenSlideshow($(el)))
  $('.slider').each((i, el) => new Slider($(el)))
  $('.sidebar-content').each((i, el) => new SidebarContent($(el)))
  $('.entry__cover').each((i, el) => new EntryCover($(el)))
  $('.product-related-listed').each((i, el) => new ProductRelatedListed($(el)))
  $('.product-entry__hero').each((i, el) => new ProductEntryHero($(el)))
  $('.product-category-more').each((i, el) => new ProductCategoryMore($(el)))
  $('.archive-header').each((i, el) => new ArchiveHeader($(el)))

  masterTimeline = new TimelineMax({ autoRemoveChildren: true })
  masterTimeline.data = { stagger: 0.15 }
  $('.press-entry-listed').each((i, el) => new PressEntryListed($(el), masterTimeline))
  $('.entry-listed').each((i, el) => new EntryListed($(el), masterTimeline))
  $('.gallery-item').each((i, el) => new GalleryItem($(el), masterTimeline))

  TweenLite.to(
    $('.logo'),
    0.3,
    { y: '0px', ease: Power3.easeOut }
  )
}

export default {
  init () {
    const $introLogo = $('.intro-logo')
    const $introLogoSprite = $introLogo.find('.intro-logo__sprite')
    const spriteWidth = $introLogoSprite.width()
    const spriteHeight = $introLogoSprite.height()
    if (firstRun && $('body').hasClass('home')) {
      $(window).scrollTop(0)

      TweenLite.set(
        $('html, body'),
        { overflow: 'hidden' }
      )

      TweenLite.set(
        $('.fullscreen-slideshow'),
        { autoAlpha: 0 }
      )

      TweenLite.to(
        $introLogo,
        0.6,
        { backgroundColor: '#1c1c1c' }
      )

      TweenLite.delayedCall(0.6, () => {
        const animObj = { step: 0 }
        TweenLite.to(
          animObj,
          3.6,
          {
            step: 90,
            ease: SteppedEase.config(90),
            onUpdate: () => {
              if (animObj.step === 90) {
                return
              }
              const x = animObj.step % 9 * -1
              const y = Math.floor(animObj.step / 9) * -1
              TweenLite.set(
                $introLogoSprite,
                { backgroundPosition: `${x * spriteWidth}px ${y * spriteHeight}px` }
              )
            },
            onComplete: () => {
              const tl = new TimelineLite({
                onComplete: () => {
                  TweenLite.set(
                    $('html, body'),
                    { overflow: 'visible' }
                  )
                  TweenLite.set(
                    $('.fullscreen-slideshow'),
                    { autoAlpha: 1 }
                  )
                  startInit()
                },
              })

              tl
                .to(
                  $introLogoSprite,
                  0.6,
                  { autoAlpha: 0, ease: Power0.easeNone }
                )
                .to(
                  $('.intro-logo'),
                  0.6,
                  { autoAlpha: 0, ease: Power0.easeNone }
                )
            },
          }
        )
      })
    } else {
      TweenLite.set(
        $introLogo,
        { autoAlpha: 0 }
      )
      startInit()
    }

    firstRun = false
  },

  finalize () {
  },

  destroy () {
    if (masterTimeline && typeof masterTimeline.kill === 'function') {
      masterTimeline.kill()
      masterTimeline = null
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js